import dayjs from 'dayjs';

// The as-of cutoff for a point-in-time read. The backend stores and compares
// datetimes in UTC only; the viewer's local day becomes a UTC instant here:
// the start of the day after the picked LOCAL date, sent as `before`.
export const beforeForLocalDay = (day) => dayjs(day).startOf('day').add(1, 'day').toISOString();
